import { useCallback, useEffect, useState } from "react";
import { apiRequest, ApiError } from "../api/client";

const PAGE_SIZE = 25;

/** Round 54 — like usePagedList, but for the limit/offset endpoints the
 * Agency/Host/Audit routes expose (they return a plain JSON array). */
export function useOffsetList<T>(path: string, params: Record<string, string | number | undefined> = {}) {
  const [rows, setRows] = useState<T[]>([]);
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [token, setToken] = useState(0);
  const key = JSON.stringify(params);

  useEffect(() => { setPage(0); }, [key]);

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    setError(null);
    apiRequest<T[]>(path, { params: { ...params, limit: PAGE_SIZE, offset: page * PAGE_SIZE } })
      .then((r) => { if (!cancelled) setRows(r); })
      .catch((e: unknown) => { if (!cancelled) setError(e instanceof ApiError ? e.message : "could not load data"); })
      .finally(() => { if (!cancelled) setIsLoading(false); });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, key, page, token]);

  return {
    rows, isLoading, error, page, pageSize: PAGE_SIZE,
    setPage: (p: number) => setPage(Math.max(0, p)),
    hasNextPage: rows.length === PAGE_SIZE,
    reload: useCallback(() => setToken((t) => t + 1), []),
  };
}

export function fmtDuration(seconds: number): string {
  const s = Math.max(0, Math.floor(seconds || 0));
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60);
  return `${h}h ${String(m).padStart(2, "0")}m`;
}
